var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { injectIntl } from "react-intl";
import React from "react";
import classNames from "classnames";
import Signals from "../../../signals/Signals";
import ReportTableOverlay from "./ReportTableOverlay";
import { ApplicationContext } from "../../../ApplicationContext";
var ReportRow = /** @class */ (function (_super) {
    __extends(ReportRow, _super);
    function ReportRow(props) {
        var _this = _super.call(this, props) || this;
        _this.onViewReport = _this.onViewReport.bind(_this);
        return _this;
    }
    ReportRow.prototype.render = function () {
        var reportModel = this.props.reportModel;
        var classes = classNames({
            "report-row": true,
            "bg-white": true,
            "w-100": true,
            'mb-4': true,
            "pl-3": true,
            "pr-3": true,
            'pt-4': true,
            'pb-4': true,
        });
        return (React.createElement("div", { style: { display: "contents" }, className: classes, "data-id": reportModel.id, onClick: this.onViewReport },
            React.createElement("div", { className: "text-nowrap" }, reportModel.title),
            React.createElement("div", null, reportModel.description),
            React.createElement("div", { className: "text-nowrap" }, reportModel.category)));
    };
    /**
     *
     * @param event
     */
    ReportRow.prototype.onViewReport = function (event) {
        var reportId = event.currentTarget.dataset.id;
        var _a = this.context, session = _a.session, reportCollection = _a.reportCollection;
        var reportModel = reportCollection.findById(reportId);
        Signals.ShowOverlay.dispatch(React.createElement(ReportTableOverlay, { reportModel: reportModel }));
    };
    return ReportRow;
}(React.Component));
ReportRow.contextType = ApplicationContext;
export default injectIntl(ReportRow);
